import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';
import { IGroup } from '../types/IGroup';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITypedIdWithName } from '../types/ITypedId';
import { ITypedIds } from '../types/ITypedIds';
import { IUser } from '../types/IUser';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetExplicitPermissionsParams {
  authorizables: ITypedIds;
}

export interface IGetExplicitPermissionsResult extends IResult {
  permissions: IAuthorizableGranteePermissions[];
  groups: IGroup[];
  users: IUser[];
  sourceAuthorizableById?: _.Dictionary<ITypedIdWithName>;
}

export class GetExplicitPermissionsRequest extends Request<IGetExplicitPermissionsParams, IGetExplicitPermissionsResult> {
  constructor(params: IGetExplicitPermissionsParams) {
    super('getExplicitPermissions', params);
  }
}
